import React, { useContext } from "react";
import axios from "axios";
import SideMenu from "../components/SideMenu";
import { toast } from "react-toastify";
import { PayPalScriptProvider } from "@paypal/react-paypal-js";
import { Paypal } from "../components/Paypal";
import { Alert } from "react-bootstrap";
import { directoryContext } from "../context/Context";

const AddListing = ({ setShowSuccess }) => {
  const [loading, setLoading] = React.useState(false);
  const {
    userState: { user },
  } = useContext(directoryContext);
  const [inputData, setInputData] = React.useState({
    businessName: "",
    listingtype: " ",
    subNiche: "null",
    subCategory: " ",
    website: " ",
    websiteURL: "",
    address: "",
    email: user?.email,
    phone: "",
    description: "",
    alexaRank: "",
    pageRank: "",
    wdRank: "",
    dScript: "",
    price: "",
  });

  const [warning, setWarning] = React.useState("");
  const [cat, setCat] = React.useState([]);
  const [subCat, setSubCat] = React.useState([]);
  React.useEffect(() => {
    if (user.type === "Free") {
      setWarning(
        "Free users can only add one listing. Please upgrade to Premium by clicking on paypal button below ."
      );
    }
    const fetchCatSubCat = async () => {
      const res = await axios.get(
        "https://www.api.webdirectories.info/api/category/get-all"
      );
      setCat(res.data);
    };
    fetchCatSubCat();
  }, []);

  React.useEffect(() => {
    const subCat = cat.filter((item) => item.parentCat === inputData.subNiche);
    setSubCat(subCat);
  }, [inputData.subNiche]);

  const handleChange = (e) => {
    setInputData({ ...inputData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await toast.promise(
        axios.post("https://www.api.webdirectories.info/api/listing", {
          ...inputData,
          /// price to number
          price: parseInt(inputData.price),
          user: user?._id,
          email: user?.email,
          name: user?.userName,
        }),

        {
          pending: "Processing...",
          success:
            "Directory is submitted successfully. Please wait for admin approval",
          error: "Something went wrong",
          position: toast.POSITION.BOTTOM_RIGHT,
        }
      );
      setInputData({
        businessName: "",
        listingtype: " ",

        website: " ",
        websiteURL: "",
        address: "",
        email: " ",
        phone: "",
        description: "",
        alexaRank: "",
        pageRank: "",
        wdRank: "",
        dScript: "",
      });
    } catch (error) {
      console.log(error.message);
    }
  };

  return (
    <div>
      <div class="container">
        <div class="row flex-nowrap">
          <SideMenu profilePic={user?.profilePic} />
          <div class="col py-3">
            <Alert variant="danger" style={{ display: warning ? "" : "none" }}>
              {warning}
            </Alert>

            <h2>Add Listing</h2>
            <form onSubmit={handleSubmit}>
              <div class="mb-3">
                <label for="exampleInputEmail1" class="form-label">
                  Business Title
                </label>
                <input
                  type="text"
                  class="form-control"
                  name="businessName"
                  value={inputData.businessName}
                  onChange={handleChange}
                />
              </div>
              <div class="mb-3">
                <label class="form-label">Address</label>
                <input
                  type="text"
                  class="form-control"
                  value={inputData.address}
                  name="address"
                  onChange={handleChange}
                />
              </div>
              <div className="row">
                <div className="col-lg-4">
                  <label for="exampleInputEmail1" class="form-label">
                    Type/Category
                  </label>
                  <select
                    class="form-select mb-3"
                    name="listingType"
                    onChange={handleChange}
                  >
                    <option defaultValue="Free">Select Listing Type</option>
                    <option value="Free">Free </option>
                    <option value="Paid">Paid</option>
                    <option value="Trusted">Trusted </option>
                    <option value="Niche">Niche </option>
                  </select>
                </div>

                {inputData.listingType === "Niche" && (
                  <div className="col-lg-4">
                    <label for="" class="form-label">
                      Sub Niche Type
                    </label>
                    <select
                      class="form-select mb-3"
                      name="listingType"
                      onChange={(e) =>
                        setInputData({ ...inputData, subNiche: e.target.value })
                      }
                    >
                      <option value={"null"}> Select Sub Niche </option>
                      {cat.map((item, index) => {
                        return (
                          <option value={item.parentCat} key={index}>
                            {item.parentCat}
                          </option>
                        );
                      })}
                    </select>
                  </div>
                )}

                {inputData.subNiche !== "null" &&
                  inputData.listingType === "Niche" && (
                    <div className="col-lg-4">
                      <label for="" class="form-label">
                        Sub Category
                      </label>
                      <select
                        class="form-select mb-3"
                        name="listingType"
                        // onChange={(e)=>setInputData({...inputData,subNiche:e.target.value})}
                        onChange={(e) =>
                          setInputData({
                            ...inputData,
                            subCategory: e.target.value,
                          })
                        }
                      >
                        <option defaultValue="Games">
                          {" "}
                          Select Sub Category{" "}
                        </option>
                        {subCat &&
                          subCat[0] &&
                          subCat[0].childCat.map((item, index) => {
                            return (
                              <option value={item} key={index}>
                                {item}
                              </option>
                            );
                          })}
                      </select>
                    </div>
                  )}

                <div className="col-lg-4">
                  <label for="exampleInputEmail1" class="form-label">
                    Website url
                  </label>
                  <input
                    type="text"
                    class="form-control"
                    name="websiteURL"
                    value={inputData.websiteURL}
                    onChange={handleChange}
                  />
                </div>
                <div className="col-lg-4">
                  <label className="form-label">Directory Script</label>
                  <input
                    type="text"
                    class="form-control"
                    name="dScript"
                    value={inputData.dScript}
                    onChange={handleChange}
                  />
                </div>

                {inputData.listingType !== "Free" && (
                  <div className="col-lg-4">
                    <label className="form-label">Price</label>
                    <input
                      type="text"
                      class="form-control"
                      name="price"
                      value={inputData.price}
                      onChange={handleChange}
                    />
                  </div>
                )}
              </div>
              <div className="row mb-3">
                <div className="col-lg-4">
                  <label for="exampleInputEmail1" class="form-label">
                    Email Address
                  </label>
                  <input
                    type="text"
                    class="form-control"
                    value={inputData.email}
                    name="email"
                    onChange={handleChange}
                  />
                </div>

                <div className="col-lg-4">
                  <label for="exampleInputEmail1" class="form-label">
                    Phone
                  </label>
                  <input
                    type="text"
                    class="form-control"
                    value={inputData.phone}
                    name="phone"
                    onChange={handleChange}
                  />
                </div>
                <div className="col-lg-4">
                  <label for="exampleInputEmail1" class="form-label">
                    Website
                  </label>
                  <input
                    type="text"
                    class="form-control"
                    value={inputData.website}
                    name="website"
                    onChange={handleChange}
                  />
                </div>
              </div>
              <div className="row mb-3">
                <div className="col-lg-4">
                  <label for="exampleInputEmail1" class="form-label">
                    Monthly Visits
                  </label>
                  <input
                    type="text"
                    class="form-control"
                    value={inputData.alexRank}
                    name="alexaRank"
                    onChange={handleChange}
                  />
                </div>

                <div className="col-lg-4">
                  <label for="exampleInputEmail1" class="form-label">
                    Domain Authority
                  </label>
                  <input
                    type="text"
                    class="form-control"
                    value={inputData.pageRank}
                    name="pageRank"
                    onChange={handleChange}
                  />
                </div>
                <div className="col-lg-4">
                  <label for="exampleInputEmail1" class="form-label">
                    WD Rank
                  </label>
                  <input
                    type="text"
                    class="form-control"
                    value={inputData.wdRank}
                    name="wdRank"
                    onChange={handleChange}
                  />
                </div>
              </div>
              <h2 className="">Details</h2>
              <div class="mb-3">
                {/* <label for="exampleInputPassword1" class="form-label">Website</label> */}
                <textarea
                  className="form-control"
                  name="description"
                  value={inputData.description}
                  onChange={handleChange}
                />
              </div>
              {user?.type === "Free" && inputData.listingType !== "Free" ? (
                <PayPalScriptProvider
                  options={{
                    "client-id":
                      "Aa-xVpLpPqG3GyzFJgsUZuEeiKFD8_Or9875TmSELmAuCMS7hWoY2niKfKhffLGW_DvfozC_GHmrbXAk",
                    components: "buttons",
                    currency: "USD",
                    "disable-funding": "credit,card,p24",
                  }}
                >
                  <Paypal currency={"USD"} setShowSuccess={setShowSuccess} />
                </PayPalScriptProvider>
              ) : (
                <button type="submit" class="btn bbtn btn-primary">
                  Submit
                </button>
              )}
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddListing;
